export const parseChannelData = (data) => {
  try {
    const parsedData = JSON.parse(data?.replace(/'/gi, '"'));
    return parsedData || {};
  } catch (e) {
    return data || {};
  }
};
